import { getAPI, postAPI, postBlobAPI, postMultipartAPI } from "./Networking";
import {
  GetPodOrdersParams,
  PodOrderBatchInventoryAllocateBody,
  PodOrderBatchPrintInwardBody,
  PodOrderBatchPrintOutwardBody,
  PodOrderListingResponse,
  PodOrderMockupsParams,
  PodOrderMockupsResponse,
  PodOrderPrintingFilesBody,
} from "../models/PodOrder/PodOrder";
import { APIResponse } from "../models/NetworkResponse";

export default class PodOrderAPI {
  getQueryParams = (params: GetPodOrdersParams): URLSearchParams => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page_no", params.page.toString());
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.status) queryParams.append("stage", params.status);
    if (params.sku) queryParams.append("sku", params.sku);
    if (params.start_date && params.start_date !== "")
      queryParams.append("start_date", params.start_date);
    if (params.end_date && params.end_date !== "")
      queryParams.append("end_date", params.end_date);
    if (params.sort_by) queryParams.append("sort_by", params.sort_by);
    if (params.sort_type) queryParams.append("sort_type", params.sort_type);
    if (params.order_ids?.length) {
      params.order_ids.forEach(id => queryParams.append("order_id", id.toString()));
    }
    if (params.printing_type) {
      queryParams.append("printing_types", params.printing_type);
    }
    return queryParams;
  };

  getPodOrders = async (params: GetPodOrdersParams): Promise<PodOrderListingResponse> => {
    try {
      const queryParams = this.getQueryParams(params);
      const response = await getAPI(
        `/v1/pod-order/progress?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  batchInventoryAllocate = async (
    body: PodOrderBatchInventoryAllocateBody,
  ): Promise<APIResponse> => {
    const response = await postAPI(`/v1/pod-order/batch-approve-sir`, body);
    return response;
  };

  batchPrintOutward = async (
    body: PodOrderBatchPrintOutwardBody,
  ): Promise<APIResponse> => {
    const response = await postAPI(`/v1/pod-order/batch-print-outward`, body);
    return response;
  };

  batchPrintInward = async (
    body: PodOrderBatchPrintInwardBody,
  ): Promise<APIResponse> => {
    const response = await postAPI(`/v1/pod-order/batch-print-inward`, body);
    return response;
  };

  uploadPodOrdersCSV = async (file: File): Promise<APIResponse> => {
    try {
      if (!file) {
        throw new Error("No file provided for upload.");
      }
      const formData = new FormData();
      formData.append("csv_file", file);
      return await postMultipartAPI(`/v1/pod-order/import-csv`, formData);
    } catch (error) {
      throw error;
    }
  };

  getPrintingFiles = async (body: PodOrderPrintingFilesBody): Promise<APIResponse> => {
    const response = await postAPI(`/v1/pod-order/printing-files`, body);
    return response;
  };

  getPodOrderMockups = async (
    params: PodOrderMockupsParams,
  ): Promise<PodOrderMockupsResponse> => {
    const response = await getAPI(`/v1/pod-order/mockups`, {
      order_id: params.order_id,
      product_id: params.product_id,
      sku: params.sku,
    });
    return response.result as PodOrderMockupsResponse;
  };
}